export const ITALY_BOUNDS = {
  north: 47.1153931748,
  south: 36.619987291,
  east: 18.4802470232,
  west: 6.7499552751,
};

export const INITIAL_COORDINATES = {
  lat: 41.89193,
  lng: 12.51133,
};

export const ZOOM_LEVELS = {
  ZOOM_LEVEL_CLUSTER_MIN: 12,
  ZOOM_LEVEL_BUILDINGS: 18,
};

export const MAP_OPTIONS_START_DEFAULT: google.maps.MapOptions = {
  center: new google.maps.LatLng(
    INITIAL_COORDINATES.lat,
    INITIAL_COORDINATES.lng,
  ),
  zoom: 6,
  mapTypeControl: false,
  streetViewControl: false,
  fullscreenControl: false,
  zoomControl: true,
  zoomControlOptions: {
    position: google.maps.ControlPosition.RIGHT_TOP,
  },
};

export const MAP_OPTIONS_START = {
  kit: MAP_OPTIONS_START_DEFAULT,
  bea: MAP_OPTIONS_START_DEFAULT,
  gba: MAP_OPTIONS_START_DEFAULT,
  bia: MAP_OPTIONS_START_DEFAULT,
  noa: MAP_OPTIONS_START_DEFAULT,
  scuole: MAP_OPTIONS_START_DEFAULT,
  darkfiber: MAP_OPTIONS_START_DEFAULT,
  noadarkfiber: MAP_OPTIONS_START_DEFAULT,
  scuoledarkfiber: MAP_OPTIONS_START_DEFAULT,
  reteprimaria: MAP_OPTIONS_START_DEFAULT,
  retesecondaria: MAP_OPTIONS_START_DEFAULT,
  bts: MAP_OPTIONS_START_DEFAULT,
  sanita: MAP_OPTIONS_START_DEFAULT,
  sanitadarkfiber: MAP_OPTIONS_START_DEFAULT,
  puntiintermedi: MAP_OPTIONS_START_DEFAULT,
  sopralluogo: MAP_OPTIONS_START_DEFAULT,
  wavelength: MAP_OPTIONS_START_DEFAULT,
};

export const CITIES_EXCEPTIONS = ['Milano', 'Bologna', 'Torino'];
export const ISTAT_CODES_EXCEPTIONS = ['015146', '037006', '001272'];

export const ico_picked = {
  url: './assets/images/picked_marker.png',
  size: new google.maps.Size(30, 40),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_pop = {
  url: './assets/images/pop_marker_edge.png',
  size: new google.maps.Size(30, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_temp = {
  url: './assets/images/gmarker.png',
  size: new google.maps.Size(30, 30),
  scaledSize: new google.maps.Size(20, 20),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_pink = {
  url: './assets/images/ico_pink.png',
  size: new google.maps.Size(20, 30),
  scaledSize: new google.maps.Size(20, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(10, 20),
};

export const ico_pop_cd = {
  url: './assets/images/ico-pop-cd.png',
  size: new google.maps.Size(30, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_pop_yellow = {
  url: './assets/images/ico-pop-yellow.png',
  size: new google.maps.Size(30, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_poi = {
  url: './assets/images/ico-poi.png',
  size: new google.maps.Size(30, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_pfs = {
  url: './assets/images/ico-pfs.png',
  size: new google.maps.Size(30, 30),
  scaledSize: new google.maps.Size(20, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_roe = {
  url: './assets/images/ico-roe.png',
  size: new google.maps.Size(30, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_cno = {
  url: './assets/images/ico-roe.png',
  size: new google.maps.Size(30, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_pozzetti = {
  url: './assets/images/ico-roe.png',
  size: new google.maps.Size(30, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 30),
};

export const ico_noa = {
  url: './assets/images/ico-noa.png',
  size: new google.maps.Size(20, 30),
  scaledSize: new google.maps.Size(20, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(10, 20),
};

export const ico_scuole = {
  url: './assets/images/ico-noa.png',
  size: new google.maps.Size(20, 30),
  scaledSize: new google.maps.Size(20, 30),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(10, 20),
};

export const ico_cluster = {
  url: './assets/images/cluster.png',
  size: new google.maps.Size(60, 60),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(30, 30),
};

export const ico_cluster_green = {
  url: './assets/images/cluster_green.png',
  size: new google.maps.Size(60, 60),
  scaledSize: new google.maps.Size(60, 60),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(30, 30),
};

export const ico_cluster_yellow = {
  url: './assets/images/cluster_yellow.png',
  size: new google.maps.Size(60, 60),
  scaledSize: new google.maps.Size(60, 60),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(30, 30),
};

export const ico_civic_marker = {
  url: './assets/images/civic_marker.png',
  size: new google.maps.Size(25, 25),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 15),
};

export const ico_civic_marker_green = {
  url: './assets/images/civic_marker_green.png',
  size: new google.maps.Size(25, 25),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 15),
};

export const ico_civic_marker_yellow = {
  url: './assets/images/civic_marker_yellow.png',
  size: new google.maps.Size(25, 25),
  origin: new google.maps.Point(0, 0),
  anchor: new google.maps.Point(15, 15),
};

export const ico_p = [
  {
    url: './assets/images/ico_p0.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  },
  {
    url: './assets/images/ico_p1.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  },
  {
    url: './assets/images/ico_p2.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  },
  {
    url: './assets/images/ico_p3.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  },
  {
    url: './assets/images/ico_p4.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  },
  {
    url: './assets/images/ico_p5.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  },
  {
    url: './assets/images/ico_p6.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  },
  {
    url: './assets/images/ico_p7.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  },
  {
    url: './assets/images/ico_p8.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  },
  {
    url: './assets/images/ico_p9.png',
    size: new google.maps.Size(20, 30),
    scaledSize: new google.maps.Size(20, 30),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(10, 20),
  }
]


export const icons_pops = {
  national: ico_pop,
  provincial: ico_pop,
  cd: ico_pop_cd,
  agf: ico_pop_yellow
};

export const civic_markers = {
  coveredab: ico_civic_marker,
  coveredcd: ico_civic_marker_green,
  coveredfwa: ico_civic_marker_green,
  coveredagf: ico_civic_marker_yellow,
  bts: ico_noa,
  armadio: ico_noa,
  centrale: ico_noa,
  coverednoacd: ico_noa,
  coveredschoolcd: ico_noa,
  coveredhealthcarecd: ico_noa,
  coveredpozzettocd: ico_noa,
  coveredcnocd: ico_noa,
  coveredroecd: ico_noa
};

export const clusters = {
  CoveredAB: ico_cluster,
  CoveredCD: ico_cluster_green,
  CoveredFWA: ico_cluster_green,
  CoveredAGF: ico_cluster_yellow,
  CoveredNoaCD: ico_cluster,
  CoveredSchoolCD: ico_cluster,
  CoveredHealthcareCD: ico_cluster
};

export function buildingLabelsStack(element) {
  const result = [];
  if (element && element.building_labels && element.building_labels.length) {
    for (const l of element.building_labels) {
      result.push(l);
    }
  } else if (element && element.identifier_of) {
    const label = '#' + element.identifier_of;
    result.push(label);
  } else if (element && element.indirizzo_completo) {
    const label = element.indirizzo_completo;
    result.push(label);
  } else if (element && element.points) {
    for (const l of Object.values(element.points)) {
      result.push(l);
    }
  } else if (element && element.code) {
      result.push(element.code);
  }
  return result.join('<br />');
}
